// User Model
import { Model } from '@vuex-orm/core';

export default class Participant extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'participants'

  // List of all fields (schema) of the post model. `this.attr` is used
  // for the generic field type. The argument is the default value.
  static fields() {
      return {
          answers: this.attr(null),
          avatar: this.attr(''),
          firstname: this.attr(''),
          id:  this.attr(null),
          lastname: this.attr(''),
          level: this.attr(1),
          name: this.attr(''),
          picture: this.attr(''),
          posts: this.attr(null),
          profile: this.attr(null),
          topics: this.attr(null),
          username: this.attr(''),
      };
  }

  static apiConfig = {
      actions: {
          fetchByQuery(user) {
              // return a promise with the result so we can use the pagination data
              return new Promise((resolve) => {

                params.append('model', 'users');
                params.append('query', user);

                  this.get(`/api/v3/search`, {
                      params,
                      save:false
                  }).then((response) => {
                      resolve(response.data.data);
                  });
              });
          },
      },
  }
}

window.Participant = Participant;
